import PropTypes from 'prop-types';
import styles from './FJAIVideoGeneratorLeft.module.less';
import { AI_GENERATOR_VIDEO_TAB_TYPE } from '../../../../config/dataConfig/FJAIVideoGeneratorData.js';
import FJAITextOrImageToVideo from './FJAITextOrImageToVideo.jsx';
import FJAIVideoEffectContainer from '../container/FJAIVideoEffectContainer.jsx';
import FJUtil from '../../../../util/FJUtil.js';

const FJAIVideoGeneratorLeft = props => {
    const {
        tabIndex,
        currentRatio,
        changeRatio,
        currentQuality,
        currentDuration,
        totalCredit,
        onChangeQuality,
        onChangeDuration,
        originImage,
        textValue,
        onTextValueChange,
        uploadFile,
        isDraggingFile,
        setIsDraggingFile,
        uploadStatus,
        onGenerate,
        getInspire,
        showAIImageHistoryList,
        taskStatus,
        isProjectLoading,
        freeNumCreation,
        creditNumber,
        onFileDelete,
        openMediaLibrary,
        audioActive,
        onChangeAudioActive,
        currentModel,
        defaultFreeNumCreation,
        onChangeModel,
        currentResolution,
        onChangeResolution,
        imageMode,
        onChangeCharacterOrientation,
        curCharacterOrientation,
        onMotionControlPresetClick,
        motionControlTextSwitch,
        setMotionControlTextSwitch,
    } = props;

    const isTextOrImage = [
        AI_GENERATOR_VIDEO_TAB_TYPE.AI_TEXT_TO_VIDEO,
        AI_GENERATOR_VIDEO_TAB_TYPE.AI_IMAGE_TO_VIDEO,
    ].includes(tabIndex);

    return (
        <div
            className={styles.left_container}
            style={{ borderLeft: FJUtil.isAiVideoGeneratorLandingPage() ? 'none' : '' }}
        >
            {isTextOrImage ? (
                <FJAITextOrImageToVideo
                    tabIndex={tabIndex}
                    currentRatio={currentRatio}
                    changeRatio={changeRatio}
                    currentQuality={currentQuality}
                    currentDuration={currentDuration}
                    currentResolution={currentResolution}
                    onChangeResolution={onChangeResolution}
                    totalCredit={totalCredit}
                    onChangeQuality={onChangeQuality}
                    onChangeDuration={onChangeDuration}
                    originImage={originImage}
                    textValue={textValue}
                    onTextValueChange={onTextValueChange}
                    uploadFile={uploadFile}
                    isDraggingFile={isDraggingFile}
                    setIsDraggingFile={setIsDraggingFile}
                    uploadStatus={uploadStatus}
                    onGenerate={onGenerate}
                    getInspire={getInspire}
                    showAIImageHistoryList={showAIImageHistoryList}
                    taskStatus={taskStatus}
                    isProjectLoading={isProjectLoading}
                    freeNumCreation={freeNumCreation}
                    creditNumber={creditNumber}
                    onFileDelete={onFileDelete}
                    openMediaLibrary={openMediaLibrary}
                    audioActive={audioActive}
                    onChangeAudioActive={onChangeAudioActive}
                    currentModel={currentModel}
                    defaultFreeNumCreation={defaultFreeNumCreation}
                    onChangeModel={onChangeModel}
                    imageMode={imageMode}
                    onChangeCharacterOrientation={onChangeCharacterOrientation}
                    curCharacterOrientation={curCharacterOrientation}
                    onMotionControlPresetClick={onMotionControlPresetClick}
                    motionControlTextSwitch={motionControlTextSwitch}
                    setMotionControlTextSwitch={setMotionControlTextSwitch}
                />
            ) : (
                <FJAIVideoEffectContainer
                    freeNumCreation={freeNumCreation}
                    textValue={textValue}
                    onTextValueChange={onTextValueChange}
                />
            )}
        </div>
    );
};

FJAIVideoGeneratorLeft.propTypes = {
    currentRatio: PropTypes.string,
    changeRatio: PropTypes.func,
    onChangeQuality: PropTypes.func,
    onChangeDuration: PropTypes.func,
    currentQuality: PropTypes.number,
    currentDuration: PropTypes.number,
    tabIndex: PropTypes.string,
    onChangeTabIndex: PropTypes.func,
    originImage: PropTypes.object,
    textValue: PropTypes.string,
    onTextValueChange: PropTypes.func,
    uploadFile: PropTypes.func,
    isDraggingFile: PropTypes.bool,
    setIsDraggingFile: PropTypes.func,
    uploadStatus: PropTypes.string,
    getInspire: PropTypes.func,
    showAIImageHistoryList: PropTypes.func,
    onFileDelete: PropTypes.func,
    openMediaLibrary: PropTypes.func,
    onGenerate: PropTypes.func,
    taskStatus: PropTypes.string,
    freeNumCreation: PropTypes.number,
    creditNumber: PropTypes.number,
    peopleImageInfo: PropTypes.object,
    clothesImageInfo: PropTypes.object,
    onUploadImage: PropTypes.func,
    selectedStyle: PropTypes.string,
    onSelectStyle: PropTypes.func,
    isProjectLoading: PropTypes.bool,
    totalCredit: PropTypes.number,
    audioActive: PropTypes.bool,
    onChangeAudioActive: PropTypes.func,
    currentModel: PropTypes.string,
    defaultFreeNumCreation: PropTypes.number,
    onChangeModel: PropTypes.func,
    currentResolution: PropTypes.string,
    onChangeResolution: PropTypes.func,
    imageMode: PropTypes.string,
    onChangeCharacterOrientation: PropTypes.func,
    curCharacterOrientation: PropTypes.string,
    onMotionControlPresetClick: PropTypes.func,
};
export default FJAIVideoGeneratorLeft;
